
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./components/App/App";
import "./helpers/i18n";

ReactDOM.render(
  <App />,
  document.getElementById("root") as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx